import api from '@services/api';
import { DetailsRequest, UndoUnionDetailsRequest, UnitDetailsRequest } from '../models/details';
import { DetailsEquipmentUpdateRequest, EquipmentResponse, EquipmentTransfer } from '../models/detailsEquipment';

/**
 * <p>
 * API endpoints that cover all details equipment related CRUD calls
 */
export const detailsEquipmentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchEquipment: builder.query<EquipmentResponse, DetailsRequest>({
      query: (params: DetailsRequest) => ({
        url: encodeURI(
          `report/details-equipment/search?project=${params.project}&period=${params.period}&subGroup=${params.subGroup}&searchTerm=${params.searchTerm}`,
        ),
      }),
      providesTags: ['SearchEquipment', 'SearchDetails'],
    }),
    updateDetailsEquipment: builder.mutation<void, DetailsEquipmentUpdateRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-equipment/update`),
        method: 'PUT',
        body: project,
      }),
      invalidatesTags: ['SearchEquipment'],
    }),
    UnitDetailsEquipment: builder.mutation<void, UnitDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-equipment/group`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchEquipment'],
    }),
    undoUnionDetailsEquipment: builder.mutation<void, UndoUnionDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-equipment/ungroup`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchEquipment'],
    }),
    equipmentTransfer: builder.mutation<void, EquipmentTransfer>({
      query: (project) => ({
        url: encodeURI(`/report/details-equipment/transfer`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchEquipment', 'SearchDetailsConstruction', 'SearchDetails'],
    }),
  }),
});

export const {
  useSearchEquipmentQuery,
  useUpdateDetailsEquipmentMutation,
  useUnitDetailsEquipmentMutation,
  useUndoUnionDetailsEquipmentMutation,
  useEquipmentTransferMutation,
} = detailsEquipmentApi;
